import L from 'leaflet'
import { ZOOM } from '~HIOR/constants/mapBounds'
import { MapLayer, LayerManager } from '~HIOR/classes/map'

class PDOKAerialProvider extends MapLayer {
    constructor () {
        super('Luchtfoto')
    }

    render (options = {}) {
        return [
            new L.TileLayer(
                'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0?layer=Actueel_ortho25&style=default&tilematrixset=EPSG%3A28992&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A28992%3A{z}&TileCol={x}&TileRow={y}', {
                    maxZoom: 12,
                    minZoom: ZOOM,
                    attribution: '<a href="http://www.pdok.nl">PDOK</a>',
                    continuousWorld: true,
                    ...options,
                }),
            new L.TileLayer(
                'https://geodata.nationaalgeoregister.nl/tiles/service/wmts?layer=lufolabels&style=default&tilematrixset=EPSG%3A28992&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A28992%3A{z}&TileCol={x}&TileRow={y}', {
                    minZoom: 8,
                    maxZoom: 12,
                    attribution: '<a href="http://www.pdok.nl">PDOK</a>',
                    continuousWorld: true,
                    ...options,
                }),
        ]
    }
}

LayerManager.register(PDOKAerialProvider)
